import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/400-italic.css";
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/libre-baskerville/400-italic.css";
import { ApplicationRoot } from "./ApplicationRoot";
import "./styles.css";
import "./instance.css";
import "./dark-theme.generated.css";
const root = createRoot(document.getElementById("root")!);
const render = () =>
  root.render(
    <React.StrictMode>
      <ApplicationRoot />
    </React.StrictMode>,
  );
render();
